import Vue from 'vue';
import {open_graph_scraper} from '@/config/endpoints';

export function fetchOpenGraphData(url){
    return Vue.http.get(open_graph_scraper + '?url=' + encodeURI(url)).then(resp => resp.body);
}